import { Component, input, model, OnInit } from '@angular/core';
import { ReactiveFormsModule, AbstractControl, FormControl } from '@angular/forms';

import { DynamicFormField, Option } from '../../../models/dynamic-form';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-dynamic-field-select',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatChipsModule, MatIconModule],
  templateUrl: './dynamic-field-select.html',
  styleUrl: './dynamic-field-select.css'
})
export class DynamicFieldSelect implements OnInit
{
  public field = input.required<DynamicFormField>();
  public control = model.required<AbstractControl>();
  public options: Option[] = [];
  public formControl!: FormControl;
  public label: string = '';

  ngOnInit(): void
  {
    this.formControl = this.control() as FormControl;
    this.options = this.field().renderType.options || [];    
  }

  removeChip( value: string )
  {
    // remove the value from the form control's value array
    const currentValues = this.formControl.value as string[];
    const index = currentValues.indexOf( value );
    if ( index >= 0 )
    {
      currentValues.splice( index, 1 );
      this.formControl.setValue( currentValues );
    }
  }
}
